export const getErrorMessage = (error) => {
  console.error("API Error:", error);

  // Erreur Axios avec réponse du serveur
  if (error.response) {
    return error.response.data?.message || error.message || "Erreur serveur";
  }

  // Erreur réseau (pas de réponse)
  if (error.request) {
    return "Serveur inaccessible";
  }

  // Erreur JS standard (new Error("message")) — lancée manuellement
  // ex: quand on détecte code === "ERROR" dans le service
  if (error.message) {
    return error.message;
  }

  return "Erreur inconnue";
};